export default __webpack_public_path__ + "static/media/forum-message-svgrepo-com.cff4ddd4.svg";